import styled from 'styled-components';

export const SeekInput = styled.input`
  -webkit-appearance: none;
  background: transparent;
  cursor: pointer;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: calc(50% - 10px);

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: #1998d5;
    margin-top: 2px;
  }

  &::-moz-range-thumb {
    height: 16px;
    border: 0;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: #1998d5;
  }
`;
